import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getProfilesFromReservation, updateGuestProfile } from '../api';

import { display } from './sessionSlice';
import type { RootState } from './../store';

export const updateProfile1 = createAsyncThunk<
	boolean,
	{
		transactionGUID: string;
		token: string;
		profileID: number;
		pmsProfileID: string;
		reservationID: number;
		pmsConfirmationNo: string;
		isPrimary: boolean;
		firstName: string;
		lastName: string;
		addressLine1: string;
		// documentNumber: string;
		//   documentType: string;
		// nationality: number;
		// nationalityCountry: string;
		// issueDate: string;
		// expiryDate: string;
		countryOfResidence: number;
		email: string;
		phoneNo_Res: string;
		propertyCode: string;

		vehiclePlateNo: string;
		postalCode: string;
		permitNo: string;
		euPlaceOfEntry: string;
		euDateOfEntry: Date;
		city: string;
		dateofBirthDT: string;
		dateOfBirth: string;
		issuePlace: string;

		udfFields: {
			udfCode: string;
			udfProfileValue: string;
		}[];
		profileDocuments: any[];
	}
>('Document/UpdateProfileDetails', async (profileParam, _thunkAPI) => {
	const response = await updateGuestProfile(profileParam);
	return response?.data?.result;
});
export const updateProfile = createAsyncThunk<
	boolean,
	{
		dto: any;
	}
>('Document/UpdateProfileDetails', async (profileParam, _thunkAPI) => {
	/* eslint-disable no-debugger */
	//debugger;
	/* eslint-enable no-debugger */
	const response = await updateGuestProfile(profileParam.dto);
	return response?.data?.result;
});
/* eslint-disable no-debugger */

export const fetchProfile = createAsyncThunk<
	object,
	{ profiles: object[]; profileID: number }
>('Profile/FetchProfile', async (param, _thunkAPI) => {
	const mainProfile = param.profiles.find((profile: any) => {
		return profile.profileID === param.profileID;
	});
	return mainProfile;
});

export const updateProfileID = createAsyncThunk<object, { profileID: any }>(
	'Profile/UpdateProfileID',
	async (param, _thunkAPI) => {
		return param?.profileID;
	}
);

const initialState = {
	profile: null,
	currentProfile: null,
	error: {
		updateProfile: null,
		fetchProfile: null,
	},
	profileID: null,
	isPostComplete: false,
} as any;

const profileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {
		clear: (state) => {
			state.profile = null;
			state.profileID = null;
		},
		resetPostComplete: (state) => {
			state.isPostComplete = false;
		},
		setProfileID: (state, action) => {
			state.profile.profileID = action?.payload;
		},
		setCurrentProfile: (state, action) => {
			state.currentProfile = action?.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(updateProfile.fulfilled, (state, action) => {
			state.profile = null;
			state.error.updateProfile = null;
			state.isPostComplete = true;
		});

		builder.addCase(updateProfile.rejected, (state, action) => {
			state.error.updateProfile = action?.error;
		});

		builder.addCase(fetchProfile.fulfilled, (state, action) => {
			state.profile = action?.payload;
			state.error.fetchProfile = null;
			if (state.profile === undefined) {
				state.error.fetchProfile = 'Profile not found';
			}
		});

		builder.addCase(fetchProfile.rejected, (state, action) => {
			state.error.fetchProfile = action?.error;
		});

		builder.addCase(updateProfileID.fulfilled, (state, action) => {
			state.profileID = action?.payload;
		});
	},
});

export const selectProfile = (state: RootState) => state.profile;
export const { clear, resetPostComplete, setProfileID, setCurrentProfile } =
	profileSlice.actions;
export default profileSlice.reducer;
